import t from 'react-translate';
import { MutableRefObject } from 'react';
import { config } from '@config/pendo.config.json';
import { useFormContext } from 'react-hook-form';
import NvIcon from 'shared/components/nv-icon';
import AthenaTextarea from 'athena/components/textarea';

type ResponseOptionsProps = {
  responseOptionsRef: MutableRefObject<HTMLTextAreaElement | null>;
  options: string;
  setOptions: (options: string) => void;
};

const ResponseOptions = ({
  responseOptionsRef,
  options,
  setOptions,
}: ResponseOptionsProps) => {
  const {
    formState: { errors },
  } = useFormContext();

  return (
    <>
      <AthenaTextarea
        required
        withForm
        ref={responseOptionsRef}
        value={options}
        showLabel={false}
        name='responseOptions'
        className='pt-2 response-options-input'
        onBlur={({ target: { value } }) => setOptions(value)}
        placeholder={t.MENTORING_PROGRAMS.SETTINGS.TABS.PROGRAM_PROFILE_SETUP.PROGRAM_LEVEL_FIELDS.PLACEHOLDERS.RESPONSE_OPTIONS()}
        dataQa={config.pendo.athena.mentorshipProgram.settings.programProfileSetup.question.questionResponseOptionsInputField}
      />
      {errors?.responseOptions && (
        <div className='d-flex mb-2'>
          <NvIcon icon='warning' size='small' className='text-danger mr-1' />
          <div className='text-danger'>{errors.responseOptions.message}</div>
        </div>
      )}
    </>
  );
};

export default ResponseOptions;
